module.exports = __webpack_public_path__ + "static/media/tijera.fe5713e2.png";